var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscussion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.901 21.153c-.085 0-.172-.016-.254-.05-.259-.104-.426-.357-.423-.636l.058-3.998H3.027C1.357 16.47 0 15.111 0 13.443V3.026C0 1.357 1.358 0 3.027 0h14.195c1.669 0 3.027 1.357 3.027 3.026v10.417c0 1.668-1.358 3.026-3.027 3.026H11.08c-.374 0-.677-.303-.677-.677 0-.374.303-.677.677-.677h6.142c.922 0 1.673-.75 1.673-1.672V3.026c0-.922-.75-1.673-1.673-1.673H3.027c-.923 0-1.674.75-1.674 1.673v10.417c0 .922.751 1.672 1.674 1.672h1.941c.181 0 .355.073.482.202.127.13.197.304.195.485l-.042 2.945 3.194-3.384c.256-.272.685-.285.957-.028.272.257.284.685.028.957l-4.388 4.65c-.131.138-.31.211-.493.211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.358 6.853H5.89c-.373 0-.677-.302-.677-.676 0-.374.304-.677.677-.677h8.467c.374 0 .676.303.676.676 0 .375-.302.677-.676.677M10.402 11.437h-4.51c-.374 0-.677-.303-.677-.677 0-.374.303-.677.676-.677h4.51c.375 0 .677.303.677.677 0 .374-.302.677-.676.677"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussion);
export default __webpack_public_path__ + "static/media/discussion.fe3ac63e.svg";
export { ForwardRef as ReactComponent };